// Utility function to format social links as full URLs
export const formatSocialLink = (link, platform) => {
  if (!link) return '';
  
  // If it's already a full URL, return it as is
  if (link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }
  
  // Otherwise, format it based on the platform
  const platformUrls = {
    instagram: 'https://instagram.com/',
    facebook: 'https://facebook.com/',
    twitter: 'https://twitter.com/',
    soundcloud: 'https://soundcloud.com/',
    spotify: 'https://open.spotify.com/artist/',
    website: 'https://'
  };
  
  const baseUrl = platformUrls[platform] || 'https://';
  
  // Remove any @ symbols for social platforms
  const cleanedLink = link.replace(/^@/, '');
  
  // For website, if it doesn't start with http/https, add https://
  if (platform === 'website') {
    return cleanedLink.startsWith('http') ? cleanedLink : `https://${cleanedLink}`;
  }
  
  return baseUrl + cleanedLink;
};

// Utility function to display social links in the UI
export const getSocialDisplayLink = (link, platform) => {
  if (!link) return '';
  
  // Always return the full URL for linking
  return formatSocialLink(link, platform);
};
